import { compile } from "path-to-regexp";

export const quotePurchase = compile("quotes/:id/purchase");
